// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import BudgetProfileLayout from './BudgetProfileLayout';

import BudgetService from '../../services/BudgetService';

const DeleteBudget = () => {
	const [budget, setBudget] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([BudgetService.getBudget(id)]).then(([budgetData]) => {
			setBudget(budgetData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the BudgetService to delete the budget
			await BudgetService.deleteBudget(id);

			// Redirect the user to the list of budgets
			navigate('/finances/budget');
		} catch (error) {
			console.error(
				'Erreur lors de la suppression de la prévision budgétaire',
				error
			);
		}
	};

	return (
		<BudgetProfileLayout>
			{budget && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer la prévision budgétaire{' '}
										<span className="text-uppercase">{budget.nom || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement cette prévision budgétaire.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez cette prévision budgétaire, toutes les
									données et informations associées seront définitivement
									perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer la prévision budgétaire
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</BudgetProfileLayout>
	);
};

export default DeleteBudget;
